import { motion, useInView } from "framer-motion"
import { graphql, Link } from "gatsby"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

const KoveCard = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const [hoveredIndex, setHoveredIndex] = useState(0)

  const toggleHover = index => {
    setHoveredIndex(index)
  }

  const handleMouseLeave = index => {
    setHoveredIndex(index)
  }

  if (module.hideSection === "no") {
    return (
      <motion.section
        initial="hidden"
        animate={isInView || hasPlayed ? "show" : "hidden"}
        variants={sectionShow}
        className={`verticalcard-anim bg-white-100 overflow-x-hidden pb-50 lgscreen:pb-30 lgscreen:pt-30 ${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <motion.div
          ref={ref}
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
        >
          <div className="flex flex-wrap">
            {module.cards.length > 0 &&
              module.cards.map((card, index) => (
                <div
                  className="md:w-3/12 mdscreen:w-full"
                  key={index}
                  onMouseLeave={() => handleMouseLeave(index)}
                  aria-hidden="true"
                >
                  <div className="card-anim relative h-full">
                    <Link
                      to={card.button.url}
                      className={`${hoveredIndex === index ? "animated" : ""} `}
                      onMouseEnter={() => toggleHover(index)}
                      onMouseLeave={() => toggleHover(null)}
                    >
                      {card?.image && (
                        <div className="img">
                          <ImageOpt
                            imgData={card.image.mediaItemUrl}
                            width={445}
                            height={879}
                            imgAlt={card.image.altText}
                            imgLoad="lazy"
                            imgClass="w-full h-[779px] mdscreen:h-[400px] object-cover"
                          />
                        </div>
                      )}
                      <div className="card-anim-content absolute top-50per translate-y-minus_50 w-full text-center z-9">
                        <div className="h-[150px] flex items-center justify-center">
                          {card?.letter && (
                            <div className="link-letter-stroke text-white-100 text-[110px] font-ositalic">
                              <img
                                className="mx-auto"
                                src={card.letter.mediaItemUrl}
                                width={150}
                                height={145}
                                loading="lazy"
                                alt={card.letter.altText}
                              />
                            </div>
                          )}
                          {card?.letterHover && (
                            <div
                              variants={animFade}
                              className="link-letter-fill"
                            >
                              <img
                                className="mx-auto"
                                src={card.letterHover.mediaItemUrl}
                                width={150}
                                height={145}
                                loading="lazy"
                                alt={card.letterHover.altText}
                              />
                            </div>
                          )}
                        </div>
                        {card?.heading && (
                          <h5 className="text-stone mt-55 mdscreen:mt-20">
                            {card.heading}
                          </h5>
                        )}
                        {card?.description && (
                          <div className="content white w-[255px] lgscreen:w-full lgscreen:px-15 mx-auto mdscreen:hidden">
                            <p>{card.description}</p>
                          </div>
                        )}
                        {card?.button && (
                          <div className="btn-custom mt-30 mdscreen:hidden">
                            <span className="btn btn-transparent">
                              {card.button.title}
                            </span>
                          </div>
                        )}
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
          </div>
        </motion.div>
      </motion.section>
    )
  }
  return null
}

export default KoveCard
export const PageKoveCardFragment = graphql`
  fragment PageKoveCardFragment on WpPage_Pagecontent_PageContent_KoveCard {
    extraId
    extraClass
    hideSection
    cards {
      letter {
        altText
        mediaItemUrl
      }
      letterHover {
        altText
        mediaItemUrl
      }
      image {
        altText
        mediaItemUrl
      }
      description
      heading
      button {
        target
        title
        url
      }
    }
  }
`
